import { TrustpilotCategoryRanking } from "./types";

export const TRUSTPILOT_REVIEW_PAGE_URL =
  "https://www.trustpilot.com/review/lawfully.com";

export const CATEGORY_RANKINGS: TrustpilotCategoryRanking[] = [
  {
    rank: 1,
    total: 147,
    categorySlug: "immigration_and_naturalization_service",
    url: "https://www.trustpilot.com/categories/immigration_and_naturalization_service",
  },
  {
    rank: 1,
    total: 161,
    categorySlug: "immigration_attorney",
    url: "https://www.trustpilot.com/categories/immigration_attorney",
  },
  {
    rank: 3,
    total: 2048,
    categorySlug: "legal_services",
    url: "https://www.trustpilot.com/categories/legal_services",
  },
];
